import { useMemo, useState } from "react";
import { useNavigate } from "react-router";

import Button from "../../components/Button/Button";
import InputText from "../../components/InputText/InputText";
import { useStateValue } from "../../stateProvider/stateProvider";
import Toast from "../Toast/Toast";
import { createLoginController, validateLoginForm } from "./loginController";
import "./Login.css";

const Login = () => {
  const [, dispatch] = useStateValue();
  const [login, setLogin] = useState("");
  const [pass, setPass] = useState("");
  const [logging, setLogging] = useState(false);
  const [infoType, setInfoType] = useState("");
  const [info, setInfo] = useState("");
  const navigate = useNavigate();

  const controller = useMemo(
    () =>
      createLoginController({
        dispatch,
        navigate,
        setInfoType,
        setInfo,
        setLogging,
        setLogin,
        setPass,
      }),
    [dispatch, navigate]
  );

  const handleSubmit = async () => {
    const validationError = validateLoginForm(login, pass);
    if (validationError) {
      alert(validationError);
      return;
    }

    await controller.submitLogin(login, pass);
  };

  return (
    <div className="register-wrapper">
      {infoType && (
        <Toast infoType={infoType} info={info} setInfoType={setInfoType} />
      )}

      <form className="register-form">
        {logging && <h3> Logowanie...</h3>}

        <h1 className="register-form__headline_1 uppercase">
          <span
            style={{
              fontWeight: "var(--normal-font-weight)",
              color: "var(--sec-font)",
            }}
          >
            Panel{" "}
          </span>
          Preview
        </h1>

        <h2 className="register-form__headline_2 uppercase">Logowanie</h2>

        <InputText
          placeholder="Login"
          value={login}
          text="Login: "
          name="login"
          handleChange={(e) => setLogin(e.target.value)}
        />

        <InputText
          placeholder="Haslo"
          isPassword={true}
          value={pass}
          text="Haslo: "
          name="password"
          handleChange={(e) => setPass(e.target.value)}
        />

        <Button txt="Zaloguj sie" click={handleSubmit} />
      </form>

      <section className="register-right-section">
        <img src="./Images/logo_white.png" className="register-right-section__logo" />
      </section>
    </div>
  );
};

export default Login;
